import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/propriedade' };
/////////////////////////////////////////////////////////////////////////////////

export function createPropriedadeCadastro(payload) {
  return httpService.post(args, payload);
}

export function updatePropriedadeCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listPropriedadeCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findPropriedadeCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function findAllPropriedadeCadastro() {
  return httpService.get({ ...args, path: '/propriedade/all' });
}

export function deletePropriedadeCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}

